module.exports = __webpack_public_path__ + "img/contact_ecxel.ce12d46f.png";